import { render, staticRenderFns } from "./saleCertified.vue?vue&type=template&id=98436372&scoped=true&"
import script from "./saleCertified.vue?vue&type=script&lang=js&"
export * from "./saleCertified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98436372",
  null
  
)

export default component.exports